import React, { useEffect, useState, memo } from "react";

import BootstrapTable from "react-bootstrap-table-next";
import queryString from "app/services/queryStringService";
import _ from "lodash";
import { getTransactionHistory } from "app/services/SearchService";
import Tooltip from "rc-tooltip";
import paginationFactory from "react-bootstrap-table2-paginator";
import moment from "moment";
import { Button } from "react-bootstrap";
import { AiFillFileExcel } from "react-icons/ai";

import { MdSearch } from "react-icons/md";
import queryStringService from "app/services/queryStringService";
import { exportManualCRDR } from "app/services/memberService";

const DebitTransationHistory = (props) => {
  const [page, setPage] = useState(1);
  const [data, setData] = useState([]);
  const [sizePerPage, setSizePerPage] = useState(5);
  const [dataCount, setDataCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const [memId, setMemId] = useState(0);
  const [FromDate, setFromDate] = useState("");
  const [ToDate, setToDate] = useState("");
  const [TransactionMode, setTransactionMode] = useState("Debit");

  const dateFormatter = (cell, row) => {
    return moment(cell).format("DD/MM/YYYY h:mm A");
  };

  const balanceFormatter = (cell, row) => {
    return <span>{cell ? `₹ ${cell}` : ""} </span>;
  };

  const remarksFormatter = (cell, row) => {
    return (
      <Tooltip
        placement="top"
        overlay={<div style={{ maxWidth: 250 }}>{row.userRemark}</div>}
      >
        <span> {row.userRemark.substring(0, 10)}...</span>
      </Tooltip>
    );
  };
  const columns = [
    {
      dataField: "sln",
      text: "Sln",
      headerStyle: (colum, colIndex) => {
        return { width: "80px", textAlign: "center" };
      },
    },
    {
      dataField: "member.uniqueIdentity",
      text: "Username",
      headerStyle: (colum, colIndex) => {
        return { width: "100px", textAlign: "center" };
      },
    },
    {
      dataField: "member.memberFullName",
      text: "Name",
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
    },

    {
      dataField: "member.company",
      text: "company",
      headerStyle: (colum, colIndex) => {
        return { width: "200px", textAlign: "center" };
      },
    },
    {
      dataField: "correlationId",
      text: "correlationId",
      headerStyle: (colum, colIndex) => {
        return { width: "200px", textAlign: "center" };
      },
    },
    {
      dataField: "transactionType",
      text: "Tran Type",

      headerStyle: (colum, colIndex) => {
        return { width: "100px", textAlign: "center" };
      },
    },
    {
      dataField: "ladgerDate",
      text: "Approval Date",
      formatter: dateFormatter,
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
    },
    {
      dataField: "transactionAmount",
      text: "Tran Amount",
      headerStyle: (colum, colIndex) => {
        return { width: "150px" };
      },
      formatter: balanceFormatter,
    },
    {
      dataField: "opening",
      text: "Opening Amt",
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
      formatter: balanceFormatter,
    },
    {
      dataField: "closing",
      text: "Closing Amt",
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
      formatter: balanceFormatter,
    },
    {
      dataField: "leadgerBalance",
      text: "Ledger Balance",
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
      formatter: balanceFormatter,
    },
    {
      dataField: "creditBalance",
      text: "Credit Balance",
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
      formatter: balanceFormatter,
    },
    {
      dataField: "userRemark",
      text: "Remark",
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
      formatter: remarksFormatter,
    },
  ];
  const rowStyle = (row, rowIndex) => {
    const style = {};
    style.textAlign = "center";
    style.fontWeight = "600";
    style.verticalAlign = "center";
    return style;
  };
  const NoDataIndication = () => {
    if (loading) {
      return (
        <div className="jumbotron jumbotron-fluid min-vh-80 m-0 bg-white"></div>
      );
    } else {
      return (
        <div className="jumbotron min-vh-80 text-middle m-0 text-center d-flex flex-column justify-content-center">
          <span className="align-middle"></span>
          <p> No Data Found</p>
        </div>
      );
    }
  };

  const loadTransaction = async () => {
    const query = queryString.getQueryStringFromObj({
      pageNumber: page,
      pageSize: sizePerPage,
      FromDate,
      ToDate,
      TransactionMode: "Debit",
    });
    if (dataCount !== 0) {
      setLoading(true);
    }
    const response = await getTransactionHistory(props.memberId, query);
    const responseData = response.data.data;
    const paggingData = JSON.parse(response.headers["x-pagination"]);
    setData(responseData);
    setDataCount(paggingData.TotalCount);
    setPage(paggingData.CurrentPage);
    setSizePerPage(paggingData.PageSize);
    setLoading(false);
  };

  useEffect(() => {
    // Fetch data whenever the memberId changes
    if (props.memberId && props.memberId !== memId) {
      const timeoutId = setTimeout(async () => {
        await loadTransaction();
      }, 100);
      return () => clearTimeout(timeoutId);
    }
  }, [props.memberId, memId, props.isTransComplete]);

  const handleTableChange = async (type, { page, sizePerPage }) => {
    const currentIndex = (page - 1) * sizePerPage;
    setPage(page);
    setSizePerPage(sizePerPage);
    await loadTransaction();
  };

  const handleSearchChanges = (e) => {
    const { name, value } = e.target;
    switch (name) {
      case "FromDate":
        setFromDate(value);
        break;
      case "ToDate":
        setToDate(value);
        break;
      case "TransactionMode":
        setTransactionMode(value);
        break;
      default:
        break;
    }
  };

  const handleSearch = async () => {
    setPage(1);
    setSizePerPage(10);
    await loadTransaction();
  };

  // const exportTransLog = async () => {
  //   const query = queryStringService.getQueryStringFromObj({
  //     pageNumber: page,
  //     pageSize: sizePerPage,
  //     FromDate,
  //     ToDate,
  //     TransactionMode: "Debit",
  //   });
  //   if (dataCount !== 0) {
  //     setLoading(true);
  //   }
  //   const response = await exportManualCRDR(query);
  //   if (response) {
  //     const url = window.URL.createObjectURL(new Blob([response.data]));
  //     const link = document.createElement("a");
  //     link.href = url;
  //     link.setAttribute("download", `${moment().toISOString()}_DebitList.xlsx`);
  //     document.body.appendChild(link);
  //     link.click();
  //     document.body.removeChild(link);
  //   }
  //   setLoading(false);
  // };

  // const handleExport = () => {
  //   setPage(1);
  //   setSizePerPage(10);
  //   setTimeout(async () => {
  //     await exportTransLog();
  //   }, 10);
  // };

  const refreshFilter = async (e) => {
    setFromDate("");
    setToDate("");
    setTransactionMode("");
    await loadTransaction();
  };

  const paginationOptions = {
    paginationSize: 5,
    pageStartIndex: 1,
    firstPageText: "First",
    prePageText: "Back",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First page",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    totalSize: dataCount,
    sizePerPageList: [
      {
        text: "10",
        value: 10,
      },
      {
        text: "15",
        value: 15,
      },
      {
        text: "20",
        value: 20,
      },
      {
        text: "50",
        value: 50,
      },
    ],
    sizePerPageRenderer: ({
      options,
      currSizePerPage,
      onSizePerPageChange,
    }) => (
      <>
        <label className="mr-2">Page Size </label>
        <div className="btn-group mr-4" role="group">
          {options.map((option) => {
            const isSelect = currSizePerPage === `${option.page}`;
            return (
              <button
                key={option.text}
                type="button"
                onClick={() => onSizePerPageChange(option.page)}
                className={`btn btn-sm ${
                  isSelect ? "btn-primary" : "btn-secondary"
                }`}
              >
                {option.text}
              </button>
            );
          })}
        </div>
      </>
    ),
  };

  return (
    <>
      <div className="card card-body mb-3">
        <div className="row mb-2">
          <div className="col-md-4">
            <div className="form-group">
              <label> Date From</label>
            </div>
            <input
              type="date"
              className="form-control"
              name="FromDate"
              value={FromDate}
              onChange={handleSearchChanges}
            />
          </div>
          <div className="col-md-4">
            <div className="form-group">
              <label> Date To</label>
            </div>
            <input
              type="date"
              className="form-control"
              name="ToDate"
              value={ToDate}
              onChange={handleSearchChanges}
            />
          </div>
          {/* <div className="col-md-3">
            <div className="form-group">
              <label> Search Text</label>
            </div>
            <input
              type="text"
              className="form-control"
              name="TransactionMode"
              value={TransactionMode}
              onChange={handleSearchChanges}
            />
          </div> */}
          <div
            className="col-md-4 d-flex justify-content-center"
            style={{ marginTop: "37px" }}
          >
            <button
              className="btn btn-outline-primary  d-flex align-items-center"
              onClick={handleSearch}
            >
              <MdSearch className="mx-2" size={18} />
            </button>

            <button
              className="btn btn-outline-primary d-flex align-items-center ms-3"
              onClick={refreshFilter}
            >
              {" "}
              Refresh
              {/* <MdRefresh className="mx-2" size={18} /> */}
            </button>
            {/* <Button
              variant="outline-primary"
              onClick={handleExport}
              disabled={!dataCount}
            >
              Export
              <AiFillFileExcel className=" " />
            </Button> */}
          </div>
        </div>

        <div style={{ overflow: "auto" }}>
          <BootstrapTable
            hover
            remote
            keyField="uniqueIdentity"
            data={data}
            columns={columns}
            pagination={paginationFactory(paginationOptions)}
            onTableChange={handleTableChange}
            noDataIndication={NoDataIndication}
            headerClasses="bg-primary text-white"
            bodyClasses="react-bootstrap-table-next-min-height"
            rowStyle={rowStyle}
          />
        </div>
      </div>
    </>
  );
};

export default memo(DebitTransationHistory);
